import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "font-weight-bold mb-4" }
const _hoisted_3 = { class: "card" }
const _hoisted_4 = { class: "card-header header-elements-inline" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h6", { class: "card-title" }, "Verwalten Sie Ihre Benutzer", -1)
const _hoisted_6 = { class: "header-elements" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { class: "media-list media-list-linked media-list-bordered" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "mr-3 d-flex flex-column align-items-center" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "icon-user" }, null, -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { class: "media-body overflow-hidden d-flex flex-column flex-md-row flex-wrap" }
const _hoisted_14 = { class: "mr-3 text-wrap" }
const _hoisted_15 = { class: "mr-3" }
const _hoisted_16 = { class: "text-muted text-opac-right float-left w-100" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "ml-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "list-icons" }, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "#",
      class: "list-icons-item"
    }, [
      /*#__PURE__*/_createElementVNode("i", { class: "icon-arrow-right15" })
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FilterBar = _resolveComponent("FilterBar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.headline), 1),
    _createVNode(_component_FilterBar, {
      filter: _ctx.filter,
      search: _ctx.search,
      onFilter: _ctx.onFilter
    }, null, 8, ["filter", "search", "onFilter"]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", {
            class: "btn btn-accent btn-sm",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.newEmployee && _ctx.newEmployee(...args))),
            disabled: !_ctx.userRights.user?.write
          }, "Neuen Benutzer anlegen", 8, _hoisted_7)
        ])
      ]),
      _createElementVNode("ul", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (user, index) => {
          return (_openBlock(), _createElementBlock("li", {
            key: index,
            class: ""
          }, [
            _createElementVNode("a", {
              class: "media cursor-pointer align-items-center",
              onClick: ($event: any) => (_ctx.editEmployee(user))
            }, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("a", {
                  href: "#",
                  class: _normalizeClass(["btn bg-transparent rounded-pill border-2 btn-icon ml-1 mr-1 ml-md-3 mr-md-3", ['text-'+_ctx.userStatus[user.status].class, 'border-'+_ctx.userStatus[user.status].class]])
                }, _hoisted_12, 2),
                _createElementVNode("small", {
                  class: _normalizeClass(["mx-auto", 'text-'+_ctx.userStatus[user.status].class])
                }, _toDisplayString(_ctx.userStatus[user.status].name), 3)
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("span", _hoisted_14, _toDisplayString(user.firstName) + " " + _toDisplayString(user.lastName), 1),
                _createElementVNode("span", _hoisted_15, [
                  _createElementVNode("i", {
                    class: _normalizeClass(["icon-envelop", user.invitation == 1 ? 'text-primary' : 'text-secondary'])
                  }, null, 2),
                  _createElementVNode("i", {
                    class: _normalizeClass(["icon-user-check ml-2", user.verified == 1 ? 'text-primary' : 'text-secondary'])
                  }, null, 2)
                ]),
                _createElementVNode("div", _hoisted_16, _toDisplayString(user.email), 1)
              ]),
              _hoisted_17
            ], 8, _hoisted_9)
          ]))
        }), 128))
      ])
    ])
  ]))
}